export const leftNavData = [
    {title: '客户管理', icon: 'el-icon-user', path: '/customer', role: ['ADMIN', 'MANAGER', 'AUDIT'], sonMenu: []},
    // {title: '首页', icon: 'el-icon-s-grid', path: '/index', role: ['USER'], condition:`type==="PROJECT"&&realName==="guest"`, sonMenu: []},
    // {title: '项目信息总览', icon: 'el-icon-s-grid', path: '/index', role: [], condition:`realName!=="guest"`, sonMenu: []},
    {title: '项目信息总览', icon: 'el-icon-s-grid', path: '/index', role: [], sonMenu: []},
    {title: '多样性交付系统', icon: 'el-icon-c-scale-to-original', path: '/projectBz', role: [], sonMenu: []},
    {title: '功能基因扩增子交付系统', icon: 'el-icon-c-scale-to-original', path: '/projectBzFun', role: [], sonMenu: [],isNeedNewIcon:true},
    {title: '宏基因组交付系统', icon: 'el-icon-c-scale-to-original', path: '/projectMetag', role: [], sonMenu: []},
    {title: '转录组交付系统', icon: 'el-icon-c-scale-to-original', path: '/projectTrans', role: [], sonMenu: []},
    {title: '代谢组交付系统', icon: 'el-icon-c-scale-to-original', path: '/projectMetabo', role: [], sonMenu: []},
    {title: '单细胞交付系统', icon: 'el-icon-c-scale-to-original', path: '/projectSingleCell', role: [], sonMenu: [],isNeedNewIcon:true},
    {title: '转录和代谢联合分析交付系统', icon: 'el-icon-c-scale-to-original', path: '/projectTransMetabo', role: [], sonMenu: [],isNeedNewIcon:true},
    {title: '多样性和代谢联合分析交付系统', icon: 'el-icon-c-scale-to-original', path: '/projectBzMetabo', role: [], sonMenu: [],isNeedNewIcon:true},
    {title: '鱼类eDNA交付系统', icon: 'el-icon-c-scale-to-original', path: '/projectEDNA', role: [], sonMenu: [],isNeedNewIcon:true},
    {
        title: '裸测项目交付系统',
        icon: 'el-icon-tickets position-relative',
        path: '/naked',
        role: [],
        redDotFc: 'getAllApprovalRedDoltNum',
        isInClass: false,
        sonMenu: [
            {
                title: '审批人员管理',
                icon: 'el-icon-user',
                path: '/nakedUser',
                role: ['ADMIN', 'MANAGER', 'AUDIT'],
                sonMenu: []
            },
            {
                title: '审批',
                icon: 'el-icon-edit-outline position-relative',
                path: '/nakedApproval',
                role: ['ADMIN', 'MANAGER',],
                sonMenu: [],
                redDotFc: 'getAllApprovalRedDoltNum',
                isInClass: false,
                viewer: {
                    content: 'approve_naked_viewer'
                },
            }, {
                title: '原始数据',
                icon: 'el-icon-tickets',
                path: '/nakedRawData',
                role: [],
                sonMenu: []
            },
        ]
    },
    {title: '其他类型项目交付系统', icon: 'el-icon-c-scale-to-original', path: '/projectRawData', role: [], sonMenu: []},

    {
        title: '报告审批管理',
        icon: 'el-icon-edit-outline position-relative',
        path: '/approve',
        role: ['ADMIN', 'MANAGER', 'AUDIT'],
        redDotFc: 'getReportRedDoltNum',
        viewer: {
            content: 'approve_report_viewer'
        },
        sonMenu: [
            {
                title: '审批人员管理',
                icon: 'el-icon-user',
                path: '/approveUser',
                role: ['ADMIN', 'MANAGER', 'AUDIT'],
                viewer: {
                    content: 'approve_report_viewer'
                },
                sonMenu: []
            },
            {
                title: '报告审批',
                icon: 'el-icon-tickets position-relative',
                path: '/approveReport',
                role: [],
                sonMenu: [],
                redDotFc: 'getReportRedDoltNum',
                viewer: {
                    content: 'approve_report_viewer'
                },
            },
        ]
    },

    {
        title: '邮件管理',
        icon: 'el-icon-message',
        path: '/email',
        role: ['ADMIN', 'MANAGER', 'ANALYST', 'AUDIT'],
        viewer: {
            content: 'approve_report_viewer'
        },
        sonMenu: []
    },
    {title: '系统配置', icon: 'el-icon-setting', path: '/config', role: ['ADMIN'], sonMenu: []},
    {title: '个人中心', icon: 'el-icon-user', path: '/info', role: ['USER'],condition:`type==="CUSTOMER"` , sonMenu: []},
    {title: '自定义绘图方案', icon: 'el-icon-price-tag', path: '/personalPlan',role: [], sonMenu: []},
    {title: '项目使用情况', icon: 'el-icon-s-custom', path: '/systemCondition',role: ['ADMIN','SALES','MANAGER'], sonMenu: []},
    {title: '更新日志', icon: 'el-icon-chat-dot-square', path: '/log',role: [], sonMenu: []},
    {title: '联系我们', icon: 'el-icon-phone-outline', path: '/contact',role: [], sonMenu: []},
]


export const needRedDoltInfo = [
    {
        sys: 'NAKED',
        setRedDoltName: 'setNakedDataReleaseRedDoltNum',
        type: 'pending',
        viewer: {
            content: 'approve_naked_viewer'
        },
        data: {
            auditStatus: ["PENDING"],
            'query#approvalType.EQ':'DATA_RELEASE'
        }
    },
    {
        sys: 'NAKED',
        setRedDoltName: 'setNakedDataReleaseRedDoltNum',
        type: 'fail',
        viewer: {
            content: 'approve_naked_viewer'
        },
        data: {
            auditStatus: ["FAILED"],
            'query#approvalType.EQ':'DATA_RELEASE'
        }
    },
    {
        sys: 'NAKED',
        setRedDoltName: 'setNakedReportRedDoltNum',
        type: 'pending',
        viewer: {
            content: 'approve_naked_viewer'
        },
        data: {
            auditStatus: ["PENDING"],
            'query#approvalType.EQ':'REPORT_UPLOAD'
        }
    },{
        sys: 'NAKED',
        setRedDoltName: 'setNakedReportRedDoltNum',
        type: 'fail',
        viewer: {
            content: 'approve_naked_viewer'
        },
        data: {
            auditStatus: ["FAILED"],
            'query#approvalType.EQ':'REPORT_UPLOAD'
        }
    },
    {
        sys: 'REPORT',
        setRedDoltName: 'setReportRedDoltNum',
        viewer: {
            content: 'approve_report_viewer'
        },
        data:
            {
                approvalStatus: ["PENDING"],
                uploaderType: "COMMON"
            },
    },
]
